import React, {useMemo, useState} from 'react'
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import {makeStyles} from '@material-ui/core/styles';
import Button from 'components/Button';
import {wasEverPublished} from "libs/getDemandStatus";
import RepoService from "services/RepoService";
import {connect} from "react-redux";
import SelectRepoDocument from "./SelectRepoDocument";

const useStyles = makeStyles(theme => ({
    firstTable: {
        marginTop: theme.spacing(5)
    }
}));

function RepoDocuments(
    {
        demandId,
        editable,
        folderList,
        demandHeader
    }) {

    const classes = useStyles();

    const [showInternalDocuments, setShowInternalDocuments] = useState(()=> folderList.length > 1 || (folderList.length === 1 && folderList[0].files.length > 0));
    const isPublished = useMemo(() => demandHeader ? wasEverPublished() : undefined, [demandHeader]);

    return (
        <GridBlock
            column
            className={classes.firstTable}
        >
            {showInternalDocuments ?
                <SelectRepoDocument
                    demandId={demandId}
                    disabled={!editable}
                    isPublished={isPublished}
                    folderList={folderList}
                />
                :
                <Button
                    onClick={() => setShowInternalDocuments(true)}
                    variant="outlined"
                    disabled={!editable}
                >
                    {Tr("add_inner_document")}
                </Button>
            }
        </GridBlock>
    )
}

export default connect((state) => ({
    folderList: state.resources[RepoService.FOLDER_LIST_RESOURCE_ID],
    demandHeader: state.resources.demandHeader
}), {})(RepoDocuments);